export default __webpack_public_path__ + "static/media/CT_BestBuy.8bcfb083.png";